"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationTabs = void 0;
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _upsellActions = require("../../store/upsell/upsellActions");
var _useAppDispatch = require("../useAppDispatch");
const useRecommendationTabs = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const onTabSwitch = productId => {
    dispatch((0, _recommendationActions.updateSelectedHandset)(productId));
    dispatch((0, _upsellActions.removeDisplayedUpsellProductDetails)());
  };
  return {
    onTabSwitch
  };
};
exports.useRecommendationTabs = useRecommendationTabs;